import React from 'react'

const Blessing: React.FC = () => {
	return (
		<div className='timeline--blessing timeline-section'>
			<h3>
				Mummy Lilian! <span> A whole blessing.</span>
			</h3>
			<p>We give thanks to God for this work; Do you have testimonies or well wishes? She’s reading them!</p>

			<a href='https://gratico.app/mummy-lillian' className='timeline--blessing__button'>
				Share here{' '}
				<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
					<path
						d='M4.16669 9.99996H15.8334M15.8334 9.99996L10 4.16663M15.8334 9.99996L10 15.8333'
						stroke='#101828'
						strokeWidth='2'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
				</svg>
			</a>

			<div className='timeline--blessing__bg'></div>
		</div>
	)
}

export default Blessing
